module.exports = __webpack_public_path__ + "flag.2A4ioyEz.svg";